import React from "react"
import IconActivityIndicatorSmallFill from "../icons/iconActivityIndicatorSmallFill.svg"
import IconActivityIndicatorSmallTrack from "../icons/iconActivityIndicatorSmallTrack.svg"
import IconActivityIndicatorMediumFill from "../icons/iconActivityIndicatorMediumFill.svg"
import IconActivityIndicatorMediumTrack from "../icons/iconActivityIndicatorMediumTrack.svg"
import IconActivityIndicatorLargeFill from "../icons/iconActivityIndicatorLargeFill.svg"
import IconActivityIndicatorLargeTrack from "../icons/iconActivityIndicatorLargeTrack.svg"

export default function ListRow(props) {
  const { size } = props
  switch(size) {
    case 'small':
      return (
        <div className={`activityIndicator small ${ props.color }`}>
          <IconActivityIndicatorSmallFill className="activityIndicatorFill"/>
          <IconActivityIndicatorSmallTrack className="activityIndicatorTrack"/>
        </div>
      )
    case 'medium':
      return (
        <div className={`activityIndicator medium ${ props.color }`}>
          <IconActivityIndicatorMediumFill className="activityIndicatorFill"/>
          <IconActivityIndicatorMediumTrack className="activityIndicatorTrack"/>
        </div>
      )
    case 'large':
      return (
        <div className={`activityIndicator large ${ props.color }`}>
          <IconActivityIndicatorLargeFill className="activityIndicatorFill"/>
          <IconActivityIndicatorLargeTrack className="activityIndicatorTrack"/>
        </div>
      )
    default:
      return (
        <div className={`activityIndicator small ${ props.color }`}>
          <IconActivityIndicatorLargeFill className="activityIndicatorFill"/>
          <IconActivityIndicatorLargeTrack className="activityIndicatorTrack"/>
        </div>
      )
  }
}

